package io.horion.cv.pages.dashboard

import androidx.compose.runtime.*
import io.horion.cv.components.auth.RequireAuth
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import io.horion.cv.components.layouts.AppResponsiveLayout
import io.horion.cv.components.shared.DashboardCardBlock
import io.horion.cv.styles.CreateDocumentCardTextStyle
import io.horion.cv.styles.SearchButtonResponsiveStyle
import io.horion.cv.styles.SearchButtonStyle
import io.horion.cv.styles.SearchFieldWrapperStyle
import io.horion.cv.styles.SearchFormStyle
import io.horion.cv.styles.SpanStyleCSS
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import io.horion.cv.utils.Constants.UBUNTU
import kotlinx.browser.document
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Hr
import org.jetbrains.compose.web.dom.Input
import org.w3c.dom.HTMLElement
import org.w3c.dom.events.Event

private val rayonOptions = listOf("2 km", "5 km", "10 km", "15 km", "25 km", "50 km", "100 km")

private val paysPreferred = listOf(
    "Cameroun", "Allemagne", "France", "Pays-Bas", "Suède"
)

private val paysTous = listOf(
    "Afghanistan", "Afrique du Sud", "Albanie", "Algérie", "Allemagne", "Andorre",
    "Angola", "Anguilla", "Antarctique", "Antigua-et-Barbuda", "Argentine", "Arménie",
    "Australie", "Autriche", "Azerbaïdjan", "Bahamas", "Bahreïn", "Bangladesh",
    "Belgique", "Bénin", "Bolivie", "Bosnie-Herzégovine", "Botswana", "Brésil",
    "Bulgarie", "Burkina Faso", "Burundi", "Cambodge", "Cameroun", "Canada",
    "Chili", "Chine", "Chypre", "Colombie", "Congo", "Corée du Sud",
    "Costa Rica", "Côte d'Ivoire", "Croatie", "Cuba", "Danemark", "Djibouti",
    "Égypte", "Espagne", "États-Unis", "Éthiopie", "Finlande", "France",
    "Gabon", "Ghana", "Grèce", "Guatemala", "Guinée", "Haïti",
    "Hongrie", "Inde", "Indonésie", "Irak", "Iran", "Irlande",
    "Israël", "Italie", "Jamaïque", "Japon", "Jordanie", "Kazakhstan",
    "Kenya", "Liban", "Libye", "Luxembourg", "Madagascar", "Malaisie",
    "Mali", "Maroc", "Mauritanie", "Mexique", "Moldavie", "Monaco",
    "Mongolie", "Mozambique", "Myanmar", "Namibie", "Niger", "Nigéria",
    "Norvège", "Nouvelle-Zélande", "Ouganda", "Ouzbékistan", "Pakistan", "Panama",
    "Paraguay", "Pays-Bas", "Pérou", "Philippines", "Pologne", "Portugal",
    "Qatar", "République tchèque", "Roumanie", "Royaume-Uni", "Russie", "Rwanda",
    "Arabie Saoudite", "Sénégal", "Serbie", "Sierra Leone", "Singapour", "Slovaquie",
    "Somalie", "Soudan", "Suède", "Suisse", "Syrie", "Tanzanie",
    "Tchad", "Thaïlande", "Togo", "Tunisie", "Turquie", "Ukraine",
    "Uruguay", "Venezuela", "Vietnam", "Yémen", "Zambie", "Zimbabwe"
).distinct().sorted()

private const val ATTR_RAYON = "data-rayon-panel"
private const val ATTR_PAYS  = "data-pays-panel"

@Page("emploi")
@OptIn(DelicateApi::class)
@Composable
fun OffresEmploisPage() = RequireAuth {

    val ctx = rememberPageContext()

    var emploiQuery by remember { mutableStateOf("") }
    var lieuQuery   by remember { mutableStateOf("") }
    var selectedRayon by remember { mutableStateOf("25 km") }
    var selectedPays  by remember { mutableStateOf("Cameroun") }

    var showRayonMenu by remember { mutableStateOf(false) }
    var showPaysMenu  by remember { mutableStateOf(false) }
    var paysSearch    by remember { mutableStateOf("") }

    val results = remember { listOf<String>() }

    DisposableEffect(Unit) {

        val closeMenus = {
            showRayonMenu = false
            showPaysMenu = false
        }

        val clickListener: (Event) -> Unit = { event ->
            val target = event.target as? HTMLElement

            val insideRayon = target?.closest("[$ATTR_RAYON]") != null
            val insidePays  = target?.closest("[$ATTR_PAYS]") != null

            if (!insideRayon) showRayonMenu = false
            if (!insidePays)  showPaysMenu = false
        }

        val scrollListener: (Event) -> Unit = {
            closeMenus()
        }

        document.addEventListener("click", clickListener, true)
//        document.addEventListener("scroll", scrollListener, true)
//        document.addEventListener("wheel", scrollListener, true)
//        document.addEventListener("touchmove", scrollListener, true)

        onDispose {
            document.removeEventListener("click", clickListener, true)
//            document.removeEventListener("scroll", scrollListener, true)
//            document.removeEventListener("wheel", scrollListener, true)
//            document.removeEventListener("touchmove", scrollListener, true)
        }
    }

    AppResponsiveLayout(
        activeLabel = "Offres d'emplois"
    ) {
        Column(
            modifier = Modifier.fillMaxWidth().gap(24.px)
        ) {

            SpanText(
                text = "Offres d'emplois",
                modifier = SpanStyleCSS.toModifier()
                    .fontFamily(UBUNTU)
                    .fontWeight(FontWeight.SemiBold)
                    .color(Colors.DarkBlue)
            )

            Div(SearchFormStyle.toModifier().toAttrs()) {
                Box(modifier = SearchFieldWrapperStyle.toModifier()) {
                    SearchField(
                        label = "Emploi recherché",
                        value = emploiQuery,
                        placeholderText = ""
                    ) { emploiQuery = it }
                }

                Box(modifier = SearchFieldWrapperStyle.toModifier()) {
                    SearchField(
                        label = "Lieu",
                        value = lieuQuery,
                        placeholderText = "Yaoundé"
                    ) { lieuQuery = it }
                }

                SearchButton {}
            }

//            if (isMobile) {
//                Column(modifier = Modifier
//                    .fillMaxWidth()
//                    .gap(10.px)
//                ) {
//                    SearchField(
//                        label = "Emploi recherché",
//                        value = emploiQuery,
//                        placeholderText = "",) { emploiQuery = it }
//                    SearchField(
//                        label = "Lieu",
//                        value = lieuQuery,
//                        placeholderText = "Yaoundé"
//                    ) { lieuQuery = it }
//                    SearchButton {}
//                }
//            } else {
//                Row(
//                    modifier = Modifier
//                        .fillMaxWidth()
//                        .gap(12.px),
//                    verticalAlignment = Alignment.Bottom
//                ) {
//                    Box(
//                        modifier = Modifier.weight(1f)
//                    ) {
//                        SearchField(
//                            label = "Emploi recherché",
//                            value = emploiQuery,
//                            placeholderText = ""
//                        ) { emploiQuery = it }
//                    }
//                    Box(
//                        modifier = Modifier.weight(value = 1f)
//                    ) {
//                        SearchField(
//                            label = "Lieu",
//                            value = lieuQuery,
//                            placeholderText = "Yaoundé"
//                        ) { lieuQuery = it }
//                    }
//                    SearchButton {}
//                }
//            }

            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .gap(value = 12.px),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Div(
                    attrs = Modifier
                        .position(Position.Relative)
                        .toAttrs { attr(ATTR_RAYON, value = "true") }
                ) {
                    Row(
                        modifier = Modifier
                            .height(36.px)
                            .backgroundColor(Colors.White)
                            .border(1.px, LineStyle.Solid, Colors.lineBorder)
                            .borderRadius(20.px)
                            .padding(leftRight = 14.px)
                            .cursor(Cursor.Pointer)
                            .gap(6.px)
                            .onClick { showRayonMenu = !showRayonMenu; showPaysMenu = false },
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Image(
                            src = "/location.svg",
                            description = "Rayon",
                            modifier = Modifier.size(16.px)
                        )
                        SpanText(
                            text = selectedRayon,
                            modifier = Modifier
                                .fontFamily(INTER)
                                .fontSize(14.px)
                                .color(Colors.Black)
                        )
                        Image(
                            src = if (showRayonMenu) "/arrow-up1.svg" else "/arrow-down1.svg",
                            description = "",
                            modifier = Modifier.size(16.px)
                        )
                    }

                    if (showRayonMenu) {
                        Column(
                            modifier = Modifier
                                .position(Position.Absolute)
                                .top(42.px)
                                .left(0.px)
                                .width(180.px)
                                .backgroundColor(Colors.White)
                                .border(1.px, LineStyle.Solid, Colors.lineBorder)
                                .borderRadius(10.px)
                                .padding(topBottom = 8.px, leftRight = 0.px)
                                .zIndex(100)
                                .boxShadow(offsetX = 0.px, offsetY = 4.px, blurRadius = 12.px, color = Colors.HalfBlack)
                        ) {
                            SpanText(
                                text = "RAYON",
                                modifier = Modifier
                                    .fontFamily(INTER)
                                    .fontSize(12.px)
                                    .fontWeight(FontWeight.Bold)
                                    .color(Colors.Black)
                                    .padding(leftRight = 16.px, topBottom = 8.px)
                            )
                            rayonOptions.forEach { option ->
                                DropdownItem(
                                    label = option,
                                    isSelected = option == selectedRayon,
                                    onClick = { selectedRayon = option; showRayonMenu = false }
                                )
                            }
                        }
                    }
                }

                Div(
                    attrs = Modifier
                        .position(Position.Relative)
                        .toAttrs { attr(ATTR_PAYS, "true") }
                ) {
                    Row(
                        modifier = Modifier
                            .height(36.px)
                            .backgroundColor(Colors.White)
                            .border(1.px, LineStyle.Solid, Colors.lineBorder)
                            .borderRadius(20.px)
                            .padding(leftRight = 14.px)
                            .cursor(Cursor.Pointer)
                            .gap(6.px)
                            .onClick { showPaysMenu = !showPaysMenu; showRayonMenu = false },
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Image(
                            src = "/globe.svg",
                            description = "Pays",
                            modifier = Modifier.size(16.px)
                        )
                        SpanText(
                            text = selectedPays,
                            modifier = Modifier
                                .fontFamily(INTER)
                                .fontSize(14.px)
                                .color(Colors.Black)
                        )
                        Image(
                            src = if (showPaysMenu)  "/arrow-up1.svg" else "/arrow-down1.svg",
                            description = "",
                            modifier = Modifier
                                .size(16.px)
                        )
                    }

                    if (showPaysMenu) {
                        Column(
                            modifier = Modifier
                                .position(Position.Absolute)
                                .top(42.px)
                                .left(0.px)
                                .width(280.px)
                                .height(320.px)
                                .backgroundColor(Colors.White)
                                .border(1.px, LineStyle.Solid, Colors.lineBorder)
                                .borderRadius(10.px)
                                .overflow(Overflow.Auto)
                                .zIndex(100)
                                .boxShadow(offsetX = 0.px, offsetY = 4.px, blurRadius = 12.px, color = Colors.HalfBlack)
                        ) {
                            Column(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .padding(leftRight = 12.px, topBottom = 10.px)
                                    .gap(8.px)
                                    .backgroundColor(Colors.White)
                                    .position(Position.Sticky)
                                    .top(0.px)
                                    .zIndex(10)
                            ) {
                                SpanText(
                                    text = "PAYS",
                                    modifier = Modifier
                                        .fontFamily(INTER)
                                        .fontSize(16.px)
                                        .fontWeight(FontWeight.Bold)
                                        .color(Colors.Black)
                                )

                                Input(
                                    type = InputType.Text,
                                    attrs = Modifier
                                        .fillMaxWidth()
                                        .height(34.px)
                                        .border(1.px, LineStyle.Solid, Colors.Blue)
                                        .borderRadius(6.px)
                                        .padding(leftRight = 8.px)
                                        .fontSize(16.px)
                                        .fontFamily(INTER)
                                        .color(Colors.Black)
                                        .toAttrs {
                                            placeholder("Rechercher...")
                                            value(paysSearch)
                                            onInput { paysSearch = it.value }
                                        }
                                )
                            }

                            val filteredPreferred = paysPreferred.filter { it.contains(paysSearch, ignoreCase = true) }
                            val filteredTous = paysTous.filter {
                                it.contains(paysSearch, ignoreCase = true) && it !in paysPreferred
                            }

                            filteredPreferred.forEach { pays ->
                                DropdownItem(
                                    label = pays,
                                    isSelected = pays == selectedPays,
                                    onClick = { selectedPays = pays; showPaysMenu = false; paysSearch = "" }
                                )
                            }

                            if (filteredPreferred.isNotEmpty() && filteredTous.isNotEmpty()) {
                                Hr(attrs = {
                                    style {
                                        property("width", "100%")
                                        property("height", "1px")
                                        property("background-color", "#E3E3E3")
                                        property("color", Colors.Black)
                                        property("border", "none")
                                        property("margin", "4px 0")
                                    }
                                })
                            }

                            filteredTous.forEach { pays ->
                                DropdownItem(
                                    label = pays,
                                    isSelected = pays == selectedPays,
                                    onClick = { selectedPays = pays; showPaysMenu = false; paysSearch = "" }
                                )
                            }
                        }
                    }
                }
            }

            DashboardCardBlock(minHeight = 100.px) {
                SpanText(
                    text ="Nous n'avons trouvé aucune offre d'emploi à ${if (lieuQuery.isEmpty()) selectedPays else lieuQuery}.",
                    modifier = CreateDocumentCardTextStyle.toModifier()
                        .fontFamily(INTER)
//                        .fontSize(if (isMobile) 14.px else 18.px)
                        .color(Colors.Black)
                        .textAlign(TextAlign.Center)
                )
            }
        }
    }
}

@Composable
private fun DropdownItem(
    label: String,
    isSelected: Boolean,
    onClick: () -> Unit
) {
    var hovered by remember { mutableStateOf(false) }

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .height(40.px)
            .padding(leftRight = 16.px)
            .backgroundColor(if (hovered) Colors.Blue else Colors.White)
            .cursor(Cursor.Pointer)
            .onMouseEnter { hovered = true }
            .onMouseLeave { hovered = false }
            .onClick { onClick() }
            .gap(10.px),
        verticalAlignment = Alignment.CenterVertically
    ) {
        when {
            isSelected && hovered  ->
                Image(
                    src = "/check1.svg",
                    description = "✓",
                    modifier = Modifier.size(15.px)
                )
            isSelected && !hovered ->
                Image(src = "/check.svg",
                    description = "✓",
                    modifier = Modifier.size(15.px)
                )
            else -> Box(
                modifier = Modifier
                    .width(15.px)
            )
        }
        SpanText(
            text = label,
            modifier = Modifier
                .fontFamily(INTER)
                .fontSize(14.px)
                .color(if (hovered) Colors.White else Colors.Black)
                .fontWeight(if (isSelected && !hovered) FontWeight.Medium else FontWeight.Normal)
        )
    }
}


@Composable
private fun SearchField(
    label: String,
    value: String,
    placeholderText: String,
    onValueChange: (String) -> Unit
) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .gap(6.px)
    ) {
        SpanText(
            text = label,
            modifier = Modifier
                .fontFamily(INTER)
                .fontSize(16.px)
                .color(Colors.Graytext)
                .fontWeight(FontWeight.Medium)
        )
        Input(
            type = InputType.Text,
            attrs = Modifier
                .fillMaxWidth()
                .height(44.px)
                .backgroundColor(Colors.White)
                .border(1.px, LineStyle.Solid, Colors.lineBorder)
                .borderRadius(6.px)
                .padding(leftRight = 12.px)
                .fontSize(15.px)
                .fontFamily(INTER)
                .color(Colors.Black)
                .toAttrs {
                    placeholder(placeholderText)
                    value(value)
                    onInput { onValueChange(it.value) }
                }
        )
    }
}

@Composable
private fun SearchButton(
    onClick: () -> Unit
) {
    Box(
        modifier = SearchButtonStyle.toModifier()
            .then( SearchButtonResponsiveStyle.toModifier())
            .height(44.px)
//            .margin(top = if (isMobile) 0.px else 19.px)
            .borderRadius(6.px)
//            .padding(leftRight = if (isMobile) 20.px else 28.px)
            .cursor(Cursor.Pointer)
            .onClick { onClick() },
//            .then(if (isMobile) Modifier.fillMaxWidth() else Modifier),
        contentAlignment = Alignment.Center
    ) {
        SpanText(
            text = "Rechercher",
            modifier = Modifier
                .fontFamily(INTER)
                .fontSize(15.px)
                .fontWeight(FontWeight.Medium)
                .color(Colors.White)
        )
    }
}
